module.exports = __webpack_public_path__ + "img/login-icon.0ced81f3.png";